import React from 'react';

import {MonitorMapContext, MonitorMapContextProps} from './MonitorMapContext';

const useMonitorMap = (): MonitorMapContextProps => React.useContext<MonitorMapContextProps>(MonitorMapContext);

export default useMonitorMap;
